import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Instagram, Tiktok, Youtube, Linkedin, Pinterest, Headphones, Stars, ArrowLeft } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import Modal from '../../../../../../Modal/Modal'

export default observer(function PlatformModal({ platformsModalOpen, setPlatformsModalOpen }) {
  const { campaign } = useContext(CampaignContext)

  const togglePlatform = platform => () => {
    campaign.platforms.has(platform) ? campaign.platforms.delete(platform) : campaign.platforms.add(platform)
    axiosService.patch(`/api/project_manager/campaigns/${campaign.id}`, { campaign: { platforms: Array.from(campaign.platforms) } })
    .then(() => toastSuccess('Platforms updated'))
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <Modal isOpen={platformsModalOpen} onClose={() => setPlatformsModalOpen(false)} hasSideBar>
      <Modal.Body>
        <div className="p-2">
          <div className="flex justify-between items-center pb-4">
            <h2 className='font-bold text-2xl'>Platforms</h2>
            <Modal.DissmissButton className='flex items-center p-2 rounded-lg hover:bg-gray-200'>
              <ArrowLeft className='mr-1 font-bold'/><span className='font-bold'>Back</span>
            </Modal.DissmissButton>
          </div>
          <div>
            <p className="text-md font-normal text-gray-400 pb-4 w-96">Select the platforms that are included in your campaign</p>
            <div className="flex flex-wrap justify-center gap-2 rounded-lg bg-gray-200 p-2">
              <button className={`${campaign.platforms.has('instagram') && 'bg-rb-green text-white' || 'bg-white text-black' } w-11 h-11 flex items-center justify-center border-1 rounded-md`} onClick={togglePlatform('instagram')}><Instagram /></button>
              <button className={`${campaign.platforms.has('tiktok') && 'bg-rb-green text-white' || 'bg-white text-black' } w-11 h-11 flex items-center justify-center ml-2 border-1 rounded-md`} onClick={togglePlatform('tiktok')}><Tiktok /></button>
              <button className={`${campaign.platforms.has('youtube') && 'bg-rb-green text-white' || 'bg-white text-black' } w-11 h-11 flex items-center justify-center ml-2 border-1 rounded-md`} onClick={togglePlatform('youtube')}><Youtube /></button>
              <button className={`${campaign.platforms.has('pinterest') && 'bg-rb-green text-white' || 'bg-white text-black'} w-11 h-11 flex items-center justify-center ml-2 border-1 rounded-md`} onClick={togglePlatform('pinterest')}><Pinterest /></button>
              <button className={`${campaign.platforms.has('linkedin') && 'bg-rb-green text-white' || 'bg-white text-black'} w-11 h-11 flex items-center justify-center ml-2 border-1 rounded-md`} onClick={togglePlatform('linkedin')}><Linkedin /></button>
              <button className={`${campaign.platforms.has('podcast') && 'bg-rb-green text-white' || 'bg-white text-black'} w-11 h-11 flex items-center justify-center ml-2 border-1 rounded-md`} onClick={togglePlatform('podcast')}><Headphones /></button>
              <button className={`${campaign.platforms.has('other') && 'bg-rb-green text-white' || 'bg-white text-black'} w-11 h-11 flex items-center justify-center ml-2 border-1 rounded-md`} onClick={togglePlatform('other')} title="Other"><Stars /></button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})
